export default __webpack_public_path__ + "static/media/mob_lk_320.a52343cd.webp";